/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PollReportQuestionMatrixAxis = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PollReportQuestionMatrixAxis model module.
   * @module model/PollReportQuestionMatrixAxis
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PollReportQuestionMatrixAxis</code>.
   * @alias module:model/PollReportQuestionMatrixAxis
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>PollReportQuestionMatrixAxis</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PollReportQuestionMatrixAxis} obj Optional instance to populate.
   * @return {module:model/PollReportQuestionMatrixAxis} The populated <code>PollReportQuestionMatrixAxis</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AxisTitle')) {
        obj['AxisTitle'] = ApiClient.convertToType(data['AxisTitle'], 'String');
      }
      if (data.hasOwnProperty('AxisLowPointTitle')) {
        obj['AxisLowPointTitle'] = ApiClient.convertToType(data['AxisLowPointTitle'], 'String');
      }
      if (data.hasOwnProperty('AxisHighPointTitle')) {
        obj['AxisHighPointTitle'] = ApiClient.convertToType(data['AxisHighPointTitle'], 'String');
      }
      if (data.hasOwnProperty('AxisLowPointValue')) {
        obj['AxisLowPointValue'] = ApiClient.convertToType(data['AxisLowPointValue'], 'Integer');
      }
      if (data.hasOwnProperty('AxisHighPointValue')) {
        obj['AxisHighPointValue'] = ApiClient.convertToType(data['AxisHighPointValue'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} AxisTitle
   * @default ''
   */
  exports.prototype['AxisTitle'] = '';
  /**
   * @member {String} AxisLowPointTitle
   * @default ''
   */
  exports.prototype['AxisLowPointTitle'] = '';
  /**
   * @member {String} AxisHighPointTitle
   * @default ''
   */
  exports.prototype['AxisHighPointTitle'] = '';
  /**
   * @member {Integer} AxisLowPointValue
   * @default 0
   */
  exports.prototype['AxisLowPointValue'] = 0;
  /**
   * @member {Integer} AxisHighPointValue
   * @default 0
   */
  exports.prototype['AxisHighPointValue'] = 0;



  return exports;
}));


